
import { RevButton } from '@ds/components/Button'
import { RevDivider } from '@ds/components/Divider'

import { ROUTES } from '@router'
import { trackClick } from '@tracking/events'

import { TRACKING_ZONE } from '../../Page/constants'
import UserComment from '../../UserComment'

import translations from './ReviewsList.translations'

export default {
  components: {
    RevButton,
    RevDivider,
    UserComment,
  },
  props: {
    isMaxReviewsReached: {
      type: Boolean,
      default: false,
    },
    reviews: {
      type: Array,
      required: true,
    },
    type: {
      type: Object,
      required: true,
    },
  },
  computed: {
    translations: () => translations,
    trackingInfo() {
      return {
        pageType: this.$route.name,
        zone: TRACKING_ZONE,
      }
    },
    reviewsList() {
      return this.reviews.map(
        ({
          characteristics,
          reviewInfo,
          reviewId,
          userInfo,
          productInfo,
        } = {}) => ({
          characteristics,
          comment: reviewInfo.comment,
          date: reviewInfo.date,
          purchaseDate: reviewInfo.purchaseDate,
          firstName: userInfo.firstName,
          id: reviewId,
          lastName: userInfo.lastName,
          product: productInfo,
          score: reviewInfo.rate,
          sourceCountry: reviewInfo.sourceCountry,
          trackingDetails: {
            ...this.trackingInfo,
            ...this.getProductTrackingInfo(productInfo),
          },
        }),
      )
    },
  },
  methods: {
    clickSeeMoreReviews() {
      trackClick({
        ...this.trackingInfo,
        name: 'see_more_reviews',
      })
      this.$emit('fetch-more')
    },
    getProductTrackingInfo(product) {
      switch (this.type.name) {
        case ROUTES.REVIEWS.PAGES.PRODUCT:
          return {
            uuid: this.type.productId,
            name: product.productTitle,
            model: product.modelTitle,
          }

        case ROUTES.REVIEWS.PAGES.LANDING:
          return {
            category: this.type.landingSlug,
            model: product.modelTitle,
            name: product.productTitle,
          }

        case ROUTES.REVIEWS.PAGES.MERCHANT: {
          return {
            merchantId: this.type.sellerId,
            model: product.modelTitle,
            name: product.productTitle,
          }
        }
        case ROUTES.REVIEWS.PAGES.ALL:
        default:
          return {}
      }
    },
  },
}
